const pic1 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127570/bose/gallary/ukunltulqefnqggvzsbh.jpg';
const pic2 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127659/bose/gallary/b7yuextdhqsxsvodz2om.jpg';
const pic3 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127744/bose/gallary/u4rgego4g1cvh8ws8sj5.jpg';
const pic4 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127817/bose/gallary/dqyohewbgw7eajudszsy.jpg';

const pic11 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127897/bose/gallary/gud15kpx6nrejrkx51rl.jpg';
const pic12 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127898/bose/gallary/takedl1s5uywzmz08stq.jpg';

const pic16 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127997/bose/gallary/n12igbkkksqap1ec1iyn.jpg';
const pic17 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127997/bose/gallary/ism5wkfti3tbf6rdarxi.jpg';
const pic18 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127998/bose/gallary/wvte3lcmlwy5avwqajrh.jpg';
const pic19 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721127998/bose/gallary/cb115thncu9v4zffimxp.jpg';
const pic22 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128150/bose/gallary/vhdkhijmbeachuhgffrk.jpg';
const pic24 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128151/bose/gallary/twkzgwl79h8ndoxsx48w.jpg';
const pic25 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128150/bose/gallary/hzuyfhpuhvwzpneztykn.jpg';
const pic26 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128150/bose/gallary/as8yc9ylr3ft5gggsv9f.jpg';
const pic27 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128151/bose/gallary/fnt0fi5ykwxee3y17thd.jpg';
const pic29 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128153/bose/gallary/a2kndirdxat9py6hoymk.jpg';
const pic30 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128151/bose/gallary/mufueqiengsg3g5jxf9g.jpg';
const pic31 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128703/bose/gallary/iajp3gqwi0latfiaxmzr.jpg';
const pic32 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128703/bose/gallary/fxx4czhvjiftgv5hdvhh.jpg';
const pic33 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128698/bose/gallary/kpmvfkaojiomjwp7t5ys.jpg';
const pic34 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128934/bose/gallary/lbnvg5u5ie2de7rbph6m.jpg';
const pic35 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721128979/bose/gallary/hioifkqvnqv0hginprlc.jpg';
const pic37 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129011/bose/gallary/xmktro6whirogyyrp5m3.jpg';

const pic41 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129121/bose/gallary/udzjsd4twkdawkkq6dwe.jpg';

const pic45 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129167/bose/gallary/auklc8oeojbgjhuvn4hw.jpg';
const pic47 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129229/bose/gallary/hifl3nbeqp4danweyspq.jpg';
const pic48 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129229/bose/gallary/tdoopkjndl8mmonhz5xz.jpg';
const pic49 =
  'https://res.cloudinary.com/dfglcvt2b/image/upload/v1721129228/bose/gallary/g6bxwil9vtunvhocrbtu.jpg';

export const facultyImages = [
  {
    src: pic1,
    caption: 'Respected Dr. Preeti Bajaj, Vice Chancellor, LPU',
  },
  {
    src: pic3,
    caption: 'Respected Dr. Prateek Agrawal, Head Of School CSE',
  },
  {
    src: pic4,
  },
  {
    src: pic35,
    caption: 'Respected Pro Vice Chancellor, Dr. Lovi Raj Gupta',
  },

  {
    src: pic12,
    caption: 'Respected Pro Chancellor, Madam Rashmi Mittal',
  },

  {
    src: pic32,
    caption: 'Respected Sami Anand,Associate Dean & Assistant Professor',
  },
  {
    src: pic34,
    caption: 'Respected Sorabh Lakhanpal, Senior Dean',
  },
];

export const communityImages = [
  {
    src: pic2,
  },
  {
    src: pic16,
  },
  {
    src: pic17,
  },
  {
    src: pic18,
  },
  {
    src: pic24,
  },
  {
    src: pic29,
  },
  {
    src: pic31,
  },
  {
    src: pic33,
  },
];

export const celebrityImages = [
  {
    src: pic22,
    caption: 'Faisal Malik, Guest Speaker @ Xpression',
  },
  {
    src: pic25,
    caption: 'Sourabh Dubey, Guest Speaker @ Xpression',
  },
  {
    src: pic26,
    caption:
      'Mr. Nishant Chahar(SDE Microsoft) and Mr. Subhesh Kumar (SDE Amazon,Berlin)',
  },
  {
    src: pic27,
    caption:
      'Mr. Nishant Chahar(SDE Microsoft) and Mr. Subhesh Kumar (SDE Amazon,Berlin)',
  },
  {
    src: pic30,
    caption:
      'Mr Rahul Maheshwari,Ex-Adobe,Ex-Google,Founder - LinuxSocials,90k+  followers on linkdin',
  },
  {
    src: pic47,
    caption: 'Podcast Session with Mr Nishant Chahar and Mr Subhesh Kumar',
  },
  {
    src: pic48,
    caption: 'Podcast Session with Mr Rahul Maheshwari',
  },
  {
    src: pic49,
    caption: 'Podcast Session with Mr Rahul Maheshwari',
  },
  {
    src: pic37,
    caption:
      'Mr Rahul Maheshwari,Ex-Adobe,Ex-Google,Founder - LinuxSocials,90k+  followers on linkedin',
  },
  {
    src: pic41,
    caption:
      'Mr Aman Dhattarwal, Founder of Apna Kaksha & Apna College. The most renounced Ed-Tech Youtuber with over 8 Million+ students   across   the   internet.',
  },
  {
    src: pic45,
    caption:
      'Mr Shashank Mishra, Experienced Data Engineer with a demonstrated history of working in service and product companies.',
  },
  {
    src: pic19,
    caption:
      'Mr Anuj Kumar Sharma, Ex-Amazon, Ex-Urban Company 100k+ follower on linkdin',
  },
  {
    src: pic11,
    caption:
      'Mr Rocky Bhatia, He leads the MCE area, technically drives Rocky has received 25+ Professional Awards.',
  },
];
